// extracted by mini-css-extract-plugin
module.exports = {"banner__message":"style_banner__message__tdQIV"};